export const ApiEndPoints = {
  login: "security/AuthService.svc/API/Security/",
  search: "search/PropertySearchService.svc/API/SavedSearch",
  watchlist: "search/PropertySearchService.svc/API/Watchlist",
  address: "address/suburbautocomplete.svc/API/Address",
  seo: "reiapi/api/Seo/suburb-insights",
  parameter: "search/ParameterService.svc/API/KeyValues",
  parametersuburb: "search/ParameterService.svc/API",
  searchSummary: "search/PropertySearchService.svc/API/",
  files: "upload/FileUploadService.svc/API/Documents/",
  analyser: "analyser/AnalyserService.svc/API/Analyser",
  analyserComments: "analyser/AnalyserService.svc/API/Comments",
  anylyserfilter: "analyser/AnalyserService.svc/API/Filter",
  myaccount: "reiapi/API/myaccount",
  subscriptions: "reiapi/API/subscriptions",
  rpData: "reiapi/API/RPData",
  signUp: "reiapi/API/SignUp",
  tracker: "tracker/PortfolioService.svc/API/",
  addPaymentMethodWorkatoUrl:
    "https://www.workato.com/webhooks/rest/b83ce985-6fcd-48ba-8d8b-e829aaed14db/newccpaymentmethod",
  paymentPageUrl: "https://www.zuora.com/apps/PublicHostedPageLite.do",
  changeEmail: "zuora/AccountService.svc",
  zouraURL: "https://rest.zuora.com/v1",
  rsaSignature: "https://api.realestateinvestar.com.au/digital-signature",
  zouraExternalURL: "https://api.realestateinvestar.com.au/accounts",
} as const;
